import React from "react";
import { FilePlus2, LayoutTemplate, Check } from "lucide-react";

function Card({ selected, onClick, testId, icon: Icon, title, sub, children }) {
  return (
    <button type="button" onClick={onClick} data-testid={testId}
      className={`relative text-left p-4 rounded-xl border transition-colors ${selected ? "border-blue-500 bg-blue-500/10" : "border-slate-800 hover:border-slate-600 bg-slate-900/40"}`}>
      {selected && <span className="absolute top-3 right-3 w-5 h-5 rounded-full bg-blue-600 grid place-items-center"><Check size={12} className="text-white" /></span>}
      <div className="flex items-center gap-2 text-white font-medium pr-6"><Icon size={16} className="text-blue-400 shrink-0" /><span className="truncate">{title}</span></div>
      <div className="text-xs text-slate-500 mt-1">{sub}</div>
      {children}
    </button>
  );
}

function TaskPreview({ tasks, testId }) {
  const sorted = [...tasks].sort((a, b) => (a.task_number || 0) - (b.task_number || 0));
  return (
    <ul className="mt-3 space-y-1 text-xs text-slate-300" data-testid={testId}>
      {sorted.slice(0, 5).map((t, i) => <li key={t.id || i} className="truncate">• {t.name || "Untitled task"}</li>)}
      {sorted.length > 5 && <li className="text-slate-500">+ {sorted.length - 5} more</li>}
      {sorted.length === 0 && <li className="text-slate-500">No tasks</li>}
    </ul>
  );
}

export default function TemplateStep({ templates, templateId, onPick }) {
  return (
    <div data-testid="wizard-step-template">
      <p className="text-sm text-slate-400 mb-3">Start from scratch or reuse a saved template. Templates bring in tasks and project details. Your roles and teammates stay shared across projects.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-h-[50vh] overflow-y-auto pr-1">
        <Card selected={!templateId} onClick={() => onPick("")} testId="wizard-template-card-blank" icon={FilePlus2} title="Blank project" sub="Start with an empty task list" />
        {templates.map((t) => (
          <Card key={t.id} selected={templateId === t.id} onClick={() => onPick(t.id)} testId={`wizard-template-card-${t.id}`} icon={LayoutTemplate}
            title={t.name} sub={`${(t.source_tasks || []).length} tasks${t.source_project?.name ? ` · from ${t.source_project.name}` : ""}`}>
            {templateId === t.id && <TaskPreview tasks={t.source_tasks || []} testId={`wizard-template-preview-${t.id}`} />}
          </Card>
        ))}
      </div>
      {templates.length === 0 && (
        <p className="text-xs text-slate-500 mt-3" data-testid="wizard-template-empty-tip">
          No templates yet. To make one, open any project and click "Save as template". It will show up here next time.
        </p>
      )}
    </div>
  );
}
